import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
// eslint-disable-next-line
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";

function New() {
  const [formData, setFormDate] = useState({
    email: "",
    bussinesName: "",
    assistantName: "",
    instruction: "",
    model: "",
    description: "",
  });

  const {
    email,
    bussinesName,
    assistantName,
    instruction,
    model,
    description,
  } = formData;

  const onchange = (e) => {
    setFormDate((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onAddClick = async (e) => {
    e.preventDefault();
    try {
      console.log(formData);
      //Convert description to PDF
      const pdfContent = `
      <div>
      <div>${email}</div>
      <div>${bussinesName}</div>
      <div>${description}</div>
      </div>`;

      let opt = {
        margin: 1,
        filename: "desc.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      await html2pdf().from(pdfContent).set(opt).save();

      await axios.post("http://localhost:3001/bussines/register", formData);

      // Open the empty Google Doc URL in a new tab
      // window.open(
      //   "https://docs.google.com/document/d/YOUR_DOCUMENT_ID/edit",
      //   "_blank"
      // );
    } catch (error) {
      console.log("Axios request failed", error);
      toast.error(error);
    }
  };

  return (
    <div className="w-screen">
      <Link to={"/"}>
        <button className="m-10 px-2 py-1 bg-yellow-500 uppercase font-extrabold rounded-lg hover:bg-lime-400 ">
          home
        </button>
      </Link>

      <div className="m-10 w-2/5">
        <form action="">
          <div className="my-5 grid grid-cols-2">
            <label htmlFor="">E-mail</label>
            <input
              onChange={onchange}
              value={email}
              type="email"
              name="email"
              id=""
              className="border-2 border-blue-300 ml-5 px-2 py-1"
            />
          </div>

          <div className="my-5 grid grid-cols-2">
            <label htmlFor="">Business Name</label>
            <input
              onChange={onchange}
              value={bussinesName}
              type="text"
              name="bussinesName"
              id=""
              className="border-2 border-blue-300 ml-5 px-2 py-1"
            />
          </div>

          <div className="my-5 grid grid-cols-2">
            <label htmlFor="">Assistant Name</label>
            <input
              onChange={onchange}
              value={assistantName}
              type="text"
              name="assistantName"
              id=""
              className="border-2 border-blue-300 ml-5 px-2 py-1"
            />
          </div>

          <div className="my-5 grid grid-cols-2">
            <label htmlFor="">Instruction (optional)</label>
            <input
              onChange={onchange}
              value={instruction}
              type="text"
              name="instruction"
              id=""
              className="border-2 border-blue-300 ml-5 px-2 py-1"
            />
          </div>

          <div className="my-5 grid grid-cols-2">
            <label htmlFor="">model</label>
            <select
              value={model}
              onChange={onchange}
              name="model"
              id="model"
              className="border-2 border-blue-300 ml-5 px-2 py-1"
            >
              <option value="">Select the model</option>
              <option value="gpt-3.5-turbo-1106">gpt-3.5-turbo-1106</option>
              <option value="gpt-4-1106-preview">gpt-4-1106-preview</option>
            </select>
          </div>

          <div className="my-5 grid grid-cols-2">
            <label htmlFor="">Description</label>
            <input
              onChange={onchange}
              value={description}
              type="text"
              name="description"
              id=""
              className="border-2 border-blue-300 ml-5 px-2 py-1 h-52"
            />
          </div>

          <div className="my-5 grid grid-cols-2">
            <label htmlFor="">Add Data</label>
            <button
              onClick={onAddClick}
              className="ml-5 px-2 py-1 bg-blue-300 uppercase font-extrabold rounded-lg hover:bg-lime-400"
            >
              save data
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default New;
